<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>物料管理</el-breadcrumb-item>
            <el-breadcrumb-item>库存报警</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <!-- 侧边树 -->
      <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="itemsType"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          ></el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 84%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <div
            style=" margin: 10px 20px;display:flex;justify-content: space-between;align-items: center;height:60px"
          >
            <div class="grid-search">
              <el-input v-model="search.name" placeholder="请输入材料名称" clearable @input="watchInput">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <!-- <div style="display:flex;align-items: center;width:50%;justify-content: space-between">
              <el-date-picker
                v-model="search.date"
                @change="doFilter"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
              <el-button
                type="success"
                @click="add"
                style="margin-left:50px;background-color: #67C23A;border-color: #67C23A;"
              >查看</el-button>
            </div> -->
          </div>
          <div class="build-table">
            <el-table
              :data="listData"
              height="100%"
              style="width: 100%;"
              stripe
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.$index+1}}</a>
                </template>
              </el-table-column>
              <el-table-column label="产品编码">
                <template slot-scope="scope">
                  <a>{{scope.row.materialCoding }}</a>
                </template>
              </el-table-column>
              <el-table-column label="供应商">
                <template slot-scope="scope">
                  <a>{{ scope.row.supplier}}</a>
                </template>
              </el-table-column>
              <el-table-column label="材料名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.materialName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="规格型号" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.specifications }}</span>
                </template>
              </el-table-column>
              <el-table-column label="计量单位" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.measuringUnit }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量">
                <template slot-scope="scope">
                  <span>{{ scope.row.number }}</span>
                </template>
              </el-table-column>
              <el-table-column label="提示">
                <template>
                  <span style="color:#E6A23C;">数量不足，请补充</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    var checkPrice = (rule, value, callback) => {
      // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      if (value == '') {
        callback(new Error('请输入单价'))
      } else if (!this.isCellPrice(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('请输入正确的格式!'))
      } else {
        callback()
      }
    }
    return {
      dataTree: [
        { name: '原材料', itemsType: '1' },
        { name: '半成品', itemsType: '2' },
        { name: '成品', itemsType: '3' },
        { name: '预构件', itemsType: '4' },
      ],
      listData: [],
      search: {
        //查询
        name: '',
        groupId: '',
        date: '',
        type: '3',
        itemsType: '1',
        userType: util.session.get('roleId'),
      },
      classId: '', //班组id
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      dataText: '数据加载中...',
      uploadUrl: base.url + '/inoutApply/uploadInoutApply',
      uploadHead: {
        accessToken: this.$store.state.token,
      },
      uploadData: {
        personId: '',
        type: '3',
        itemsType: '1',
        userType: util.session.get('roleId'),
        groupId: '',
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      dialogTitle1: '导入结果',
      imoportVisible: false,
      tableData1: [],
      editFormVisible: false,
      diaTitle: '',
      editForm: {
        personId: '', //添加人
        type: '3',
        itemsType: '1',
        userType: util.session.get('roleId'),
        supplier: '', //供应商
        materialName: '', // 材料名称
        specifications: '', //规格公司
        measuringUnit: '', //计量单位
        unitPrice: '', //单价
        number: '',
        // summation:'',
        registrar: '',
        materialCoding: '',
        projectRemarks:''
      },
      unitType:[],
      teamRules: {
    
            },
    }
  },
  created() {
    // if (util.session.get('roleId') == '4') {
      this.search.groupId = util.session.get('groupId')
    // } else {
    //   this.search.groupId = util.session.get('proId')
    // }
  },
  mounted() {
    this.uploadData.personId = this.$store.state.user.id
    this.uploadData.groupId = this.search.groupId

    if (this.dataTree.length > 0) {
      this.currentNodekey = this.dataTree[0].itemsType
      this.expandedkeys.push(this.dataTree[0].itemsType)
      this.$nextTick(() => {
        // treeBox 元素的ref   value 绑定的node-key
        this.$refs.tree.setCurrentKey(this.currentNodekey)
      })
    }
    this.getData()
    // this. getMate()
  },
  methods: {
    // 搜索数据
    doFilter(index) {
      // this.search.startDate = this.date ? this.date[0] : ''
      // this.search.endDate = this.date ? this.date[1] : ''
      this.search.personStatus = index
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      myHttp.selectInventoryNumberList(this.search).then(
        function (resp) {
          if (resp.data.code == '200') {
            that.listData = []
            var list = resp.data.data.InventoryNumber||[]
            for(var i=0;i<list.length;i++){
              if(list[i].number<200){
                that.listData.push(list[i])
              }
            }
            if (resp.data.data.InventoryNumber.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function () {
          that.dataText = '服务器繁忙中，请稍后请求'
        }
      )
    },
    // 查询所有的材料编码
    // getMate(){
    //      var that = this
    //   myHttp
    //     .selectApplyCodingList({
    //       materialCoding:this.editForm.materialCoding,
    //       measuringUnit:this.editForm.measuringUnit,
    //       specifications:this.editForm.specifications,
    //       supplier:this.editForm.supplier
    //     })
    //     .then(
    //       function(resp) {
    //         if (resp.data.code == '200') {
    //           var list  =resp.data.data.ApplyCoding  && resp.data.data.ApplyCoding[0]
    //           console.log(list)
    //           if(list){
    //             that.editForm.materialCoding=list.materialCoding
    //             that.editForm.materialName = list.materialName
    //             that.editForm.measuringUnit =list.measuringUnit
    //             that.editForm.specifications = list.specifications
    //             that.editForm.supplier = list.supplier
    //           }
    //         } else {
    //           that.$message.error(resp.data.msg)
    //         }
    //       },
    //     )
    // },
    //获取字典表
    zidian() {
      var that = this
      myHttp
        .getDictByType({
          type: 'user_type',
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList || []
          }
        })
    },
    // weight_type
    // 获取计量单位
    getUnit(){
         var that = this
      myHttp
        .getDictByType({
          type: 'weight_type'
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList || []
            that.unitType= list
          }
        })
    },
    //
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val
    //   this.currentChangePage()
    // },
    // 监控当前页码
    // currentChangePage(list) {
    //   this.getData()
    // }

    //点击树形结构
    handleNodeClick(data) {
      console.log(data)
      this.search.itemsType = data.itemsType
      this.editForm.itemsType = data.itemsType

      this.getData()
      console.log(this.editForm.itemsType)
    },

    watchInput(e) {
      // console.log(e)
      this.search.personStatus = e
      this.getData()
    },
    /**添加材料 */
    add() {
      var type = this.search.type
      var itemsType = this.search.itemsType
      if(this.search.userType=='4'){
      this.$router.push({ path: '/panDian/' + type + '/' + itemsType })
      }else{
      this.$router.push({ path: '/panDiancon/' + type + '/' + itemsType })
      }
      
    },

    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editForm.personId = this.$store.state.user.id
          this.editForm.groupId = this.search.groupId
          this.editForm.itemsType = this.search.itemsType

          // this.editForm.summation= parseInt(this.editForm.unitPrice * this.editForm.number)
          myHttp.inventoryInoutApply({
           type:this.search.type,
           personId:this.$store.state.user.id,
           groupId :this.search.groupId,
           itemsType : this.search.itemsType,
           userType:this.search.userType,
           materialCoding:this.editForm.materialCoding,
           num:this.editForm.num,
           registrar:this.editForm.registrar,
           remarks:this.editForm.remarks,
          }).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('操作成功')
              that.editFormVisible = false
              that.currentPage = 1
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    /**
     * 导出合同
     */
    exportma(flag) {
      var token = util.session.get('token')
      window.open(
        myHttp.exportInoutApply +
          '?type=' +
          this.search.type +
          '&itemsType=' +
          this.search.itemsType +
          '&groupId=' +
          this.search.groupId +
          '&userType=' +
          this.search.userType +
          '&date=' +
          this.search.date +
          '&name=' +
          this.search.name +
          '&flag=' +
          flag +
          '&accessToken=' +
          token
      )
    },
    /**
     * 导入表监听方法
     */
    handleAppSuccess(res, file) {
      console.log(res)
      // if (res.code == '200') {
      // this.$message.success('上传成功')
      console.log(res)
      this.imoportVisible = true
      this.tableData1 = res.list
      this.getData()
      // } else {
      //   this.$message.error(res.msg)
      // }
    },
    //上传合同成功监听方法
    // handleAppSuccess(res, file, opt, id) {
    //   console.log(res, file, opt, id)
    //   if (res.code == '200') {
    //     //this.$message.success('上传成功')
    //     var path = res.data.saveUrls
    //     this.saveImg(id, path)
    //     //console.log(res)
    //     //this.getData()
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    // },

    //保存合同图片信息
    saveImg(id, path) {
      var that = this
      myHttp
        .saveContractImg({
          id: id,
          path: path,
        })
        .then(function (resp) {
          console.log(resp)
          if (resp.data.code == '200') {
            that.$message.success('上传成功')
            that.getData()
          } else {
            that.$message.error(resp.msg)
          }
        })
    },
    handleClose1() {
      this.imoportVisible = false
    },
    // 验证数字正则
    isCellPrice(val) {
      if (!/^[0-9]+.?[0-9]*$/.test(val)) {
        return false
      } else {
        return true
      }
    },
    // 操作
    handleEdit(index,row){
     this.editFormVisible= true
     this.getUnit()
     this.editForm={
        // type: '2',
        // itemsType: '1',
        // userType: '1',
        supplier:row.supplier, //供应商
        materialName:row.materialName, // 材料名称
        specifications:row.specifications, //规格公司
        userType: row.measuringUnit, //计量单位
        unitPrice: row.unitPrice, //单价
        number: row.number,
        // summation:'',
        registrar: '',
        materialCoding:  row.materialCoding,
        projectRemarks:''
     }
    }
  },
}
</script>
<style>
/**
*图片放大右上角关闭按钮
*/
.el-image-viewer__close i {
  font-size: 4vh;
  color: #fff;
}
/* @import '../../assets/css/common.css'; */
</style>
<style scoped>
/* .content {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 1%;
} */
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}
/* .grid-search {
  display: flex;
  justify-content: space-between;
  margin: 0px 20px 0;
  height: 66px;
} */
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.build-table {
  height: calc(100% - 80px);
}
.active {
  background: #409eff;
  color: #fff;
}
.contract-con {
  width: 100%;
  background: #fff;
  height: 125px;
  font-size: 14px;
}
.contract-con p {
  width: 100%;
  padding: 2px 20px;
  text-align: left;
}
.content
  >>> .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
  padding: 10px 0px;
}
.content >>> .el-input-group--append .el-input__inner {
  width: 200px;
}
.content >>> .el-tree {
  padding: 30px;
}
</style>